import actions from './actions'
import crudReducers from '../../crud/reducers'
export default crudReducers(actions, 'contact')
